"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = IconButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _common = require("../styles/common");
const _excluded = ["children", "disabled", "toggled", "onClick", "toggleIndicatorProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const StyledIconButton = _styledComponents.default.button`
    position: relative;

    display: inline-flex;
    vertical-align: top;
    align-items: center;
    justify-content: center;
    padding: 0;

    transition: color 0.25s ease-in;
    color: inherit;
    background: transparent;

    border: 0;
    border-radius: 50%;
    cursor: pointer;

    ${props => !props.disableHoverAnimation && (0, _common.hoverAnimation)()}
    ${props => props.disabled && _common.disabled}
    ${props => props.toggled && (0, _styledComponents.css)`
        color: white;
    `};

    &:hover {
        ${props => props.toggled && (0, _styledComponents.css)`
            color: white;
        `};
    }
`;
const ToggleIndicator = _styledComponents.default.div`
    position: absolute;
    width: 42px;
    height: 42px;
    top: -5px;
    left: -5px;

    transition: opacity 0.4s ease;
    opacity: ${props => props.toggled ? 1 : 0};

    background-color: var(--vcs-color--primary);
    border-radius: 50%;
`;
function IconButton(_ref) {
  let {
      children,
      disabled = false,
      /*
          When no toggle prop has been passed, don't show the <ToggleIndicator /> on the screen, because by default it's 42/42px
          and that might cause overflow for IconButtons that are not togglebale at all and dont need a <ToggleIndicator />.
      */
      toggled = undefined,
      onClick = console.log,
      toggleIndicatorProps = {}
    } = _ref,
    extra = _objectWithoutProperties(_ref, _excluded);
  const handleClick = () => !disabled && onClick();
  return /*#__PURE__*/_react.default.createElement(StyledIconButton, _extends({
    disabled: disabled,
    "aria-disabled": disabled,
    toggled: toggled,
    onClick: onClick,
    onKeyDown: ({
      code
    }) => code === "Enter" && handleClick()
  }, extra), [true, false].includes(toggled) && /*#__PURE__*/_react.default.createElement(ToggleIndicator, _extends({
    toggled: toggled
  }, toggleIndicatorProps)), children);
}
IconButton.propTypes = {
  toggled: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  title: _propTypes.default.string,
  // Accessibility reasons
  toggleIndicatorProps: _propTypes.default.object,
  disableHoverAnimation: _propTypes.default.bool
};